import { alert } from '../../../../lib/bootbox'
import { botFlowSelector } from '../../../../store/flow/selectors/botFlowSelector'
import { FeedbotThunk } from '../../../../store/types'
import { actions } from '../../../../store/ssml'
import { separateArrayElements } from '../../../../lib/array'
import { isTelephonySelector } from '../../../../store/flow/selectors/selectors'
import { featureValueSelector } from '../../../../store/features/selectors'
import { validateSsmlInFlow } from './validateSsmlInFlow'
import { dialogHierarchyMapSelector } from '../../../../store/flow/selectors/dialogHierarchyMapSelector'
import { containsAtLeastOneError } from '../../../ssml'

export function validateSsmlInFlowThunk(alertOnFailure?: boolean): FeedbotThunk {
  return async (dispatch, getState) => {
    const state = getState()
    const flow = botFlowSelector(state)
    const isTelephony = isTelephonySelector(state)
    const isSsmlValidationEnabled = featureValueSelector('SSML_VALIDATION')(state)
    const hierarchyMap = dialogHierarchyMapSelector(getState())
    if (!flow || !isTelephony || !isSsmlValidationEnabled) {
      dispatch(actions.setFullValidationResult({}))
      return
    }

    const results = await validateSsmlInFlow(flow, hierarchyMap)

    dispatch(actions.setFullValidationResult(results))

    const errorIds = Object.entries(results)
      .filter(([key, res]) => !!res && containsAtLeastOneError(res))
      .map(([key]) => key)

    if (!alertOnFailure || !errorIds.length) {
      return
    }

    const stepIdsSeparatedWithElements = separateArrayElements(`<br />`, errorIds, false).join('')

    return alert({
      title: '❌ SSML validation error',
      message: `Found SSML validation errors in these steps:<br />${stepIdsSeparatedWithElements}`
    })
  }
}
